module.exports = __webpack_public_path__ + "img/twitter-small.3328d3f0.svg";